import { render, staticRenderFns } from "./ClubCardGetting.vue?vue&type=template&id=2d6a2132&"
import script from "./ClubCardGetting.vue?vue&type=script&lang=js&"
export * from "./ClubCardGetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6a2132')) {
      api.createRecord('2d6a2132', component.options)
    } else {
      api.reload('2d6a2132', component.options)
    }
    module.hot.accept("./ClubCardGetting.vue?vue&type=template&id=2d6a2132&", function () {
      api.rerender('2d6a2132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/core/ClubCardGetting/ClubCardGetting.vue"
export default component.exports